import React, { useState } from 'react';
import { connect } from 'react-redux';
import { PATH_MODES } from 'constants/config';
import ConvertPathModal from './ConvertPathModal';
import Section, { SectionHeader } from './Section';

const ContentType = ({ pathId, currentMode }) => {
  const [showModal, setShowModal] = useState(false);

  const toggleModal = () => {
    setShowModal(!showModal);
  };

  return (
    <Section>
      <SectionHeader className="d-f jc-sb" htmlFor="pathDescription">
        {t('training_activity.content_button_label')}
      </SectionHeader>
      <div className="c-brand-gray-darker fw-b">
        {t('paths.path_builder.content_type.current_type_path')}
      </div>
      {currentMode !== PATH_MODES.EDIT && (
        <>
          <div className="c-brand-gray-darker mt-2">
            {t(
              'paths.path_builder.content_type.convert_to_certification.want_to_convert_question',
            )}
          </div>
          <button
            className="NewButton NewButton--white NewButton--center undecorated c-brand-gray-darker fz-16 w-fill mt-12"
            type="button"
            onClick={toggleModal}
          >
            {t(
              'paths.path_builder.content_type.convert_to_certification.convert_to_certification',
            )}
          </button>
          {showModal && (
            <ConvertPathModal pathId={pathId} closeModal={toggleModal} />
          )}
        </>
      )}
    </Section>
  );
};

const mapStateToProps = ({ pathBuilder, ...state }) => ({
  currentMode: pathBuilder.mode,
});

export default connect(mapStateToProps, null)(ContentType);
